import HttpCliente from "../HttpCliente";

export const getEnlaceCongreso = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/EnlaceCongreso/ObtenerEnlaces", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }}).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const getEnlaceCongresoHabilitados = (token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/EnlaceCongreso/ObtenerEnlacesHabilitados", {
        headers: {
            "Authorization": `Bearer ${token}`,
            'accept': 'text/plain'
        }}).then(response => {
            resolve(response.data);
            }).catch(error => {
            reject(error);
            });
        });
    }
    
export const getEnlaceCongresoId = (token, id) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/EnlaceCongreso/ObtenerEnlace/${id}`, {
        headers: {
            "Authorization": `Bearer ${token}`,
            'accept': 'text/plain'
        }}).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}

export const postEnlaceCongreso = (token, enlace) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/EnlaceCongreso/Crear", enlace, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
}

export const putEnlaceCongreso = (token, enlace) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/EnlaceCongreso/EditarEnlaceCongreso", enlace, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        }}).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

